<template>
    <select v-model="selected_month">
        <option v-for="month in months" :value="month.number">
            {{ month.name }}
        </option>
    </select>
</template>

<script>
export default {
    name: "SelectMonth",
    data() {
        return {
            selected_month: "",
            months: [
                { name: "Select Month", number: "" },
                { name: "01 - January", number: "01" },
                { name: "02 - February", number: "02" },
                { name: "03 - March", number: "03" },
                { name: "04 - April", number: "04" },
                { name: "05 - May", number: "05" },
                { name: "06 - June", number: "06" },
                { name: "07 - July", number: "07" },
                { name: "08 - August", number: "08" },
                { name: "09 - September", number: "09" },
                { name: "10 - October", number: "10" },
                { name: "11 - November", number: "11" },
                { name: "12 - December", number: "12" },
            ],
        };
    },
};
</script>

<style scoped lang="scss"></style>
